import styled from '@emotion/styled'
import React from 'react'

import { FacebookIcon, LinkedInIcon, TwitterIcon } from '@emico/icons'
import { overrideOptional } from '@emico/overrides'
import { minWidth, theme } from '@emico/styles'

import Container from './Container'
import Logo from './Logo'

const Wrapper = styled.footer`
  background: ${theme.primaryColor};
  position: relative;
  z-index: 0;
  line-height: 22px;
  margin-top: 100px;
`
const Anchor = styled.a`
  color: ${theme.backgroundColor};
  text-decoration: none;

  &:visited,
  &:active,
  &:hover {
    color: ${theme.backgroundColor};
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
  }
`
const LogoWrapper = styled.div`
  display: flex;
  width: 120px;
  margin-right: 20px;

  svg {
    fill: ${theme.backgroundColor};
    width: 100%;
  }
`
const MainFooter = styled.section`
  position: relative;
  z-index: 2;
  background: ${theme.primaryColor};
  padding: 15px 0 30px 0;
  min-height: 125px;
`
const MainFooterContainer = styled(Container)`
  @media ${minWidth('md')} {
    display: flex;
    flex-flow: row wrap;
  }
`
const MainFooterCol = styled.div`
  flex: 0 0 auto;
  @media ${minWidth('md')} {
    flex-basis: 25%;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      line-height: 2;
      margin: 0;
      text-align: left;
    }
  }
`
const SubFooter = styled.section`
  position: relative;
  z-index: 2;
  background: ${theme.primaryVariantColor};
  padding: 30px 0;
`
const SubFooterContainer = styled(Container)`
  @media ${minWidth('md')} {
    display: flex;
    flex-flow: row wrap;
  }
`
const SubFooterCol = styled.div`
  flex: 0 0 auto;
  @media ${minWidth('md')} {
    flex-basis: 50%;
  }
`
const FooterIconsContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-content: center;
  fill: ${theme.backgroundColor};

  @media ${minWidth('sm')} {
    justify-content: left;
  }
`
const FooterIcons = styled.div`
  display: flex;
  flex-flow: row;
  align-content: center;
`
const FooterIcon = styled(Anchor)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.25em;
  height: 2.25em;
  margin-left: 1rem;
  border: 2px solid ${theme.backgroundColor};
  border-radius: 50%;

  svg {
    fill: ${theme.backgroundColor};
    width: 1em;
    height: 1em;
  }
`

const Footer = () => {
  const menuLinks = ['About us', 'Customer Service']
  const serviceLinks = [
    'Magento ontwikkeling',
    'Cases',
    'Over ons',
    'Partners',
    'Blog',
    'Jobs',
    'Contact',
  ]

  return (
    <Wrapper>
      <MainFooter>
        <MainFooterContainer>
          <MainFooterCol>
            <h3>Menu</h3>
            <ul>
              {menuLinks.map((link, index) => (
                <li key={index}>
                  <Anchor href={link}>{link}</Anchor>
                </li>
              ))}
            </ul>
          </MainFooterCol>
          <MainFooterCol>
            <h3>Service</h3>
            <ul>
              {serviceLinks.map((link, index) => (
                <li key={index}>
                  <Anchor href={link}>{link}</Anchor>
                </li>
              ))}
            </ul>
          </MainFooterCol>
        </MainFooterContainer>
      </MainFooter>
      <SubFooter>
        <SubFooterContainer>
          <SubFooterCol>
            <FooterIconsContainer>
              <LogoWrapper>
                <Logo />
              </LogoWrapper>
              <FooterIcons>
                <FooterIcon
                  target="_blank"
                  href="https://www.linkedin.com/company/emico-e-commerce"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon />
                </FooterIcon>
                <FooterIcon
                  target="_blank"
                  href="https://twitter.com/Emico_NL"
                  rel="noopener noreferrer"
                >
                  <TwitterIcon />
                </FooterIcon>
                <FooterIcon
                  target="_blank"
                  href="http://www.facebook.com/emico.ecommerce"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon />
                </FooterIcon>
              </FooterIcons>
            </FooterIconsContainer>
          </SubFooterCol>
        </SubFooterContainer>
      </SubFooter>
    </Wrapper>
  )
}

export default overrideOptional(Footer)
